module.exports = __webpack_public_path__ + "static/media/rdlogo.aca24841.svg";